import { Editor, Transforms, Element as SlateElement, Node, Path } from 'slate';

import types from '../../elements/types';

function mergeListFactory(type) {

  return function mergeList(editor) {

    const { normalizeNode } = editor;

    editor.normalizeNode = ([node, path]) => {

      // Ensure the node is an element and not a text node
      if (SlateElement.isElement(node) && node.type === type) {

        const nextPath = Path.next(path);
        let previousPath = null;

        let nextNode = null;
        let previousNode = null;

        if (Node.has(editor, nextPath)) {
          nextNode = Node.get(editor, nextPath);
        }

        if (Path.hasPrevious(path)) {
          previousPath = Path.previous(path);
        }

        if (previousPath !== null && Node.has(editor, previousPath)) {
          previousNode = Node.get(editor, previousPath);
        }
        // If the next node is also a numbered-list, merge it with the current one
        if (
          nextNode &&
          SlateElement.isElement(nextNode) &&
          nextNode.type === type
        ) {
          // Merge the two adjacent numbered-list nodes
          Transforms.mergeNodes(editor, { at: nextPath });

          // Exit normalization after merging to avoid recursion
          return;
        } else if (
          previousNode &&
          SlateElement.isElement(previousNode) &&
          previousNode.type === type
        ) {
          // Merge the two adjacent numbered-list nodes
          Transforms.mergeNodes(editor, { at: path });

          // Exit normalization after merging to avoid recursion
          return;
        }
      }

      // Call the original normalizeNode to handle other cases
      normalizeNode([node, path]);
    };

    return editor;

  };

}

export const withNumberedListNormalization = mergeListFactory(types.NUMBERED_LIST);
export const withBulletedListNormalization = mergeListFactory(types.BULLETED_LIST);